import { trackCubeCustomEvent, track } from './trackingLayer.js';

interface ABTestTrackingData {
  event_context: string;
  event_content: string[];
}

export const trackABTests = () => {
  const activeABTests = getData();
  if (activeABTests && activeABTests.length > 0) {
    activeABTests.forEach(trackABTest);
  }
};

const trackABTest = (abTestData: ABTestTrackingData) => {
  trackCubeCustomEvent('ab_test', abTestData);
  track({
    event: 'testing.userAssigned',
    testing_name: abTestData.event_context,
    testing_variant: abTestData.event_content[0],
    testing_domain: 'ents',
  });
};

const getData = (): ABTestTrackingData[] => {
  const dataNode = document.querySelector<HTMLElement>('#bewerten-ab-test-tracking');
  if (dataNode) {
    try {
      return JSON.parse(dataNode.innerText);
    } catch {
      // invalid json
    }
  }
  return [];
};
